module.exports = __webpack_public_path__ + "img/ssbackpack.1209af08.svg";